<div class="confirm-del-container">
  <div class="confirm-del-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
      <path d="M12 3 1.5 21h21L12 3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <path d="M12 9.5v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <circle cx="12" cy="17" r="1" fill="currentColor" />
    </svg>
  </div>

  <h4 class="confirm-del-title">Delete Map</h4>
  <p class="confirm-del-subtitle">Because this action cannot be undone, please confirm.</p>

  <div class="confirm-del-content">
    <p>Deleting this map will:</p>

    <div class="confirmation-list">
      <label class="custom-checkbox">
        <input type="checkbox" [(ngModel)]="confirmWorldMap">
        Delete World Map
      </label>
      <label class="custom-checkbox">
        <input type="checkbox" [(ngModel)]="confirmWiki">
        Delete world Wiki pages
      </label>
      <label class="custom-checkbox">
        <input type="checkbox" [(ngModel)]="confirmGames">
        Delete all Games and associated Journal entries
      </label>
      <label class="custom-checkbox">
        <input type="checkbox" [(ngModel)]="confirmCharacters">
        Delete all Characters and associated journal entries
      </label>
    </div>

    <p class="confirm-del-note">
      All content created in this map will be disassociated from the map / characters and remain in your Content Vault, available for other maps.
    </p>

    <p class="confirm-del-note">
      If someone in your party is interested in taking over the map, contact
      <a href="mailto:support@worldtumbler.com">support&#64;worldtumbler.com</a> and we'll assist with reassignment.
    </p>
  </div>

  <div class="btn-sec">
    <button type="button" class="btn btn-outline" (click)="cancel()" [disabled]="loading">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()" [disabled]="loading || !canDelete">
      @if (loading) {
        <span class="confirm-del-spinner" aria-hidden="true"></span>
        Deleting&hellip;
      } @else {
        Delete
      }
    </button>
  </div>
</div>
